import RegisterSetupFields, { createRegisterSetup, registerSetupError, registerSetupPayload } from './RegisterSetupFields';
import RegisterDeletionPreview, { useRegisterDeletionPreview } from './RegisterDeletionPreview';
import { installRegisterSession, confirmRegisterSwitch } from '../utils/registerSession';
import React, { useState, useEffect, useContext, useRef } from 'react';
import {
Box,
Paper,
Typography,
Divider,
Tooltip,
IconButton,
Dialog,
DialogTitle,
DialogContent,
DialogActions,
TextField,
Autocomplete,
RadioGroup,
FormControlLabel,
Radio,
Switch,
FormLabel,
Button,
Snackbar,
MenuItem,
CircularProgress,
Alert,
Chip,
InputAdornment
} from '@mui/material';
import { DataGridPro, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import { Edit, Delete, CloudDownload, Add as AddIcon, Refresh as RefreshIcon, Image as ImageIcon, Login as LoginIcon, CheckCircle as CheckCircleIcon, Search as SearchIcon } from '@mui/icons-material';
import dayjs from 'dayjs';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../UserContext';
import { REGISTER_STATUSES, getRegisterStatus, filterRegisters } from './registerAdminUtils';
import { DEFAULT_CHECKLIST_QUESTIONS, DEFAULT_CHECKLIST_MAX_QUESTIONS, MAX_CHECKLIST_QUESTIONS, resolveChecklistMaxQuestions, toChecklistQuestionRows } from '../utils/checklistConfiguration';



const DatabaseManagement = () => {
const location = useLocation();
const navigate = useNavigate();
const { user } = useContext(UserContext);
const [databases, setDatabases] = useState([])                 ;
const [loading, setLoading] = useState(true);
const [loadError, setLoadError] = useState('');
const databaseLoadError = Boolean(loadError);
const [lastRefreshed, setLastRefreshed] = useState(null);
const registerParams = new URLSearchParams(location.search);
const searchQuery = registerParams.get('q') || '';
const planFilter = registerParams.get('plan') || 'all';
// Older overview links used a separate soon-to-expire access status.
const requestedStatus = registerParams.get('status') === 'expiring' ? 'active' : registerParams.get('status');
const statusFilter = REGISTER_STATUSES[requestedStatus] ? requestedStatus : 'all';
const [creating, setCreating] = useState(false);
const [deleting, setDeleting] = useState(false);
const [backingUpDb, setBackingUpDb] = useState('');
const databaseRequestId = useRef(0);
const [connectingDb, setConnectingDb] = useState('');
const [editDialogOpen, setEditDialogOpen] = useState(false)    ;
const [selectedDatabase, setSelectedDatabase] = useState(null) ;
const [newExpiryDate, setNewExpiryDate] = useState('');
const [newPlanType, setNewPlanType] = useState('');
const [newContractId, setNewContractId] = useState('');
const [snackbarMessage, setSnackbarMessage] = useState('');
const [snackbarOpen, setSnackbarOpen] = useState(false)        ;
const [customUserLimit, setCustomUserLimit] = useState('');
const [customItemLimit, setCustomItemLimit] = useState('');
const [checklistEnabled, setChecklistEnabled] = useState(false);
const [supervisorEditEnabled, setSupervisorEditEnabled] = useState(false);
const [useDefaultChecklistQuestions, setUseDefaultChecklistQuestions] = useState(true);
const [checklistMaxQuestions, setChecklistMaxQuestions] = useState(DEFAULT_CHECKLIST_MAX_QUESTIONS);
const [checklistQuestions, setChecklistQuestions] = useState(() => toChecklistQuestionRows());
const [checklistLoading, setChecklistLoading] = useState(false);
const [checklistLoadError, setChecklistLoadError] = useState(false);
const [settingsSaving, setSettingsSaving] = useState(false);
const checklistRequestId = useRef(0);
const [rfidStatisticsEnabled, setRfidStatisticsEnabled] = useState(false);
const [rfidSettingsLoading, setRfidSettingsLoading] = useState(false);
const [rfidSettingsError, setRfidSettingsError] = useState(false);
const rfidSettingsRequestId = useRef(0);
const [createDialogOpen, setCreateDialogOpen] = useState(false) ;
const [newDbName, setNewDbName] = useState('');
const [newDbExpiry, setNewDbExpiry] = useState('');
const [newDbContractId, setNewDbContractId] = useState('');
const [newDbTemplate, setNewDbTemplate] = useState('empty');
const [newDbSetup, setNewDbSetup] = useState(createRegisterSetup);
const [createError, setCreateError] = useState('');
const creationInFlight = useRef(false);
const [trialDialogOpen, setTrialDialogOpen] = useState(false);
const [trialResultDialogOpen, setTrialResultDialogOpen] = useState(false);
const [trialCompanyName, setTrialCompanyName] = useState('');
const [trialContactFirstName, setTrialContactFirstName] = useState('');
const [trialContactLastName, setTrialContactLastName] = useState('');
const [trialContactEmail, setTrialContactEmail] = useState('');
const [trialDbName, setTrialDbName] = useState('');
const [trialRegisterMode, setTrialRegisterMode] = useState('new');
const [trialExistingDbName, setTrialExistingDbName] = useState('');
const [trialExpiry, setTrialExpiry] = useState('');
const [trialContractId, setTrialContractId] = useState('');
const [trialTemplate, setTrialTemplate] = useState('demo');
const [trialSetup, setTrialSetup] = useState(() => createRegisterSetup('Starter'));
const [trialSubmitting, setTrialSubmitting] = useState(false);
const trialSubmissionInFlight = useRef(false);
const [trialResult, setTrialResult] = useState(null);
const [deleteDialogOpen, setDeleteDialogOpen] = useState(false) ;
const [dbToDelete, setDbToDelete] = useState('');
const [confirmationInput, setConfirmationInput] = useState('');
const deletionPreview = useRegisterDeletionPreview(dbToDelete, deleteDialogOpen);
const [deletionError, setDeletionError] = useState('');
const deletionInFlight = useRef(false);
const [density, setDensity] = useState("standard");
const [logoDialogOpen, setLogoDialogOpen] = useState(false);
const [logoTargetDb, setLogoTargetDb] = useState(null);
const [logoPreviewUrl, setLogoPreviewUrl] = useState('');
const [logoFile, setLogoFile] = useState(null);
const [logoUploading, setLogoUploading] = useState(false);
const [logoLoading, setLogoLoading] = useState(false);
const logoRequestId = useRef(0);
const logoMutationInFlight = useRef(false);
const trialRegisterOptions = databases.filter(db =>
!db.deletion_phase && !['postgres', 'user_management', 'template0', 'template1'].includes(db.datname)
);
const trialExistingDatabase = trialRegisterOptions.find(db => db.datname === trialExistingDbName) || null;
const trialExistingSettingsReady = !!trialExistingDatabase &&
!trialExistingDatabase.loadErrors?.some(field => ['expiry', 'plan', 'code'].includes(field)) &&
!!trialExistingDatabase.dbCode && trialExistingDatabase.dbCode !== 'N/A' &&
['Mini', 'Starter', 'Professional', 'Business', 'Custom'].includes(trialExistingDatabase.planType) &&
!!trialExistingDatabase.expiryDate && dayjs(trialExistingDatabase.expiryDate).isValid();
const fetchDatabaseData = async () => {
const requestId = ++databaseRequestId.current;
const token = localStorage.getItem('token');
if (!token) {
setLoadError('Your session is unavailable. Sign in again to load registers.');
setLoading(false);
return false;
}
setLoading(true);
setLoadError('');
try {
const headers = { Authorization: `Bearer ${token}` };
const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/databases`, { headers });
if (!Array.isArray(response.data)) throw new Error('Invalid register response');
const registerList = response.data.filter(db => !['postgres', 'user_management'].includes(db.datname));
const loadRegister = async ({ datname, deletion_phase }) => {
if (deletion_phase) return { id: datname, datname, deletion_phase, loadErrors: [], planType: 'Deletion pending' };
const name = encodeURIComponent(datname);
const paths = [
['expiry', `/api/settings/database/${name}/expiry`],
['plan', `/api/settings/database/${name}/plan-type`],
['users', `/api/admin/database/${name}/users`],
['items', `/api/admin/database/${name}/items`],
['contract', `/api/admin/database/${name}/contract`],
['code', `/api/admin/database/${name}/dbcode`],
];
const results = await Promise.allSettled(paths.map(([, path]) => axios.get(`${process.env.REACT_APP_API_BASE_URL}${path}`, { headers })));
const values = results.map(result => result.status === 'fulfilled' ? result.value.data : null);
const [expiry, plan, users, items, contract, code] = values;
return {
id: datname,
datname,
expiryDate: expiry?.expiryDate ?? null,
isExpired: expiry?.isExpired,
daysUntilExpiry: Number.isFinite(expiry?.daysUntilExpiry) ? expiry.daysUntilExpiry : undefined,
planType: plan?.planType ?? 'Unknown',
userCount: users?.display ?? (users ? `${users.count} / ${users.maxUsers}` : null),
itemCount: items?.display ?? (items ? `${items.count} / ${items.maxItems}` : null),
userLimit: users?.maxUsers,
itemLimit: items?.maxItems,
usersUsed: users?.count,
itemsUsed: items?.count,
contractId: contract?.contractId ?? null,
dbCode: code?.dbCode ?? null,
loadErrors: results.flatMap((result, index) => result.status === 'rejected' ? [paths[index][0]] : []),
};
};
const finalList = new Array(registerList.length);
let nextRegister = 0;
await Promise.all(Array.from({ length: Math.min(4, registerList.length) }, async () => {
while (nextRegister < registerList.length && requestId === databaseRequestId.current) {
const index = nextRegister++;
finalList[index] = await loadRegister(registerList[index]);
}
}));
if (requestId !== databaseRequestId.current) return false;
setDatabases(finalList);
setLastRefreshed(new Date());
return true;
} catch (err) {
if (requestId === databaseRequestId.current) {
setLoadError('Could not load registers. Check your connection and try again. Previously loaded data may be out of date.');
}
return false;
} finally {
if (requestId === databaseRequestId.current) setLoading(false);
}
};
const loadChecklistSettings = async (datname) => {
const requestId = ++checklistRequestId.current;
const token = localStorage.getItem('token');
setChecklistLoadError(false);
if (!token || !datname) {
setChecklistLoadError(true);
return;
}
setChecklistLoading(true);
try {
const res = await axios.get(
`${process.env.REACT_APP_API_BASE_URL}/api/settings/database/${encodeURIComponent(datname)}/checklist`,
{ headers: { Authorization: `Bearer ${token}` } }
);
if (requestId !== checklistRequestId.current) return;
const maxQuestions = resolveChecklistMaxQuestions(res.data?.maxQuestions);
setChecklistMaxQuestions(maxQuestions);
setChecklistEnabled(!!res.data?.checklistEnabled);
setSupervisorEditEnabled(res.data?.supervisorEditEnabled === true);
setUseDefaultChecklistQuestions(res.data?.useDefaultQuestions !== false);
setChecklistQuestions(toChecklistQuestionRows(res.data?.questions || [], maxQuestions));
} catch (err) {
if (requestId !== checklistRequestId.current) return;
console.warn(`⚠️ Error fetching checklist settings for ${datname}:`, err.response?.status || err.message);
setChecklistLoadError(true);
} finally {
if (requestId === checklistRequestId.current) setChecklistLoading(false);
}
};
const loadRfidSettings = async (datname) => {
const requestId = ++rfidSettingsRequestId.current;
setRfidSettingsLoading(true);
setRfidSettingsError(false);
try {
const token = localStorage.getItem('token');
const res = await axios.get(
`${process.env.REACT_APP_API_BASE_URL}/api/settings/database/${encodeURIComponent(datname)}/rfid`,
{ headers: { Authorization: `Bearer ${token}` } }
);
if (requestId !== rfidSettingsRequestId.current) return;
if (typeof res.data?.statisticsEnabled !== 'boolean') throw new Error('Invalid RFID settings response.');
setRfidStatisticsEnabled(res.data.statisticsEnabled);
} catch (error) {
if (requestId === rfidSettingsRequestId.current) setRfidSettingsError(true);
} finally {
if (requestId === rfidSettingsRequestId.current) setRfidSettingsLoading(false);
}
};
useEffect(() => {
fetchDatabaseData();
return () => { databaseRequestId.current += 1; logoRequestId.current += 1; checklistRequestId.current += 1; rfidSettingsRequestId.current += 1; };
}, [])              ;
const showToast = (message) => {
setSnackbarMessage(message)      ;
setSnackbarOpen(true)            ;
}                                ;
const handleIndependentRefresh = async () => {
const refreshed = await fetchDatabaseData() ;
showToast(refreshed ? 'Database list refreshed.' : 'Could not refresh the database list.');
}                                        ;
const handleEditExpiry = (database) => {
setSelectedDatabase(database)                                                   ;
setNewExpiryDate(database.expiryDate ? database.expiryDate.split('T')[0] : '');
setNewPlanType(database.planType || 'Mini');
setNewContractId(database.contractId || '');
setCustomUserLimit(database.userLimit === '∞' ? '0' : String(database.userLimit ?? ''));
setCustomItemLimit(database.itemLimit === '∞' ? '0' : String(database.itemLimit ?? ''));
setChecklistEnabled(false);
setChecklistMaxQuestions(DEFAULT_CHECKLIST_MAX_QUESTIONS);
setSupervisorEditEnabled(false);
setUseDefaultChecklistQuestions(true);
setChecklistQuestions(toChecklistQuestionRows(DEFAULT_CHECKLIST_QUESTIONS));
setRfidStatisticsEnabled(false);
setEditDialogOpen(true) ;
loadChecklistSettings(database.datname);
loadRfidSettings(database.datname);
}                       ;
const handleCloseSettings = () => {
if (settingsSaving) return;
checklistRequestId.current += 1;
rfidSettingsRequestId.current += 1;
setEditDialogOpen(false);
};
const fetchBrandingForDb = async (datname) => {
const token = localStorage.getItem('token');
if (!token || !datname) return null;
try {
const res = await axios.get(
`${process.env.REACT_APP_API_BASE_URL}/api/settings/database/${encodeURIComponent(datname)}/branding`,
{ headers: { Authorization: `Bearer ${token}` } }
);
return res.data;
} catch (err) {
console.warn(`⚠️ Error fetching branding for ${datname}:`, err.response?.status || err.message);
return null;
}
};
const handleCloseLogoDialog = () => {
if (logoMutationInFlight.current) return;
logoRequestId.current += 1;
setLogoDialogOpen(false);
};
const handleOpenLogoDialog = async (database) => {
if (logoMutationInFlight.current) return;
const requestId = ++logoRequestId.current;
setLogoTargetDb(database);
setLogoPreviewUrl('');
setLogoFile(null);
setLogoDialogOpen(true);
setLogoLoading(true);
const branding = await fetchBrandingForDb(database.datname);
if (requestId !== logoRequestId.current) return;
if (branding?.logoUrl) {
const cacheBust = branding.updatedAt ? `?v=${new Date(branding.updatedAt).getTime()}` : '';
setLogoPreviewUrl(`${process.env.REACT_APP_API_BASE_URL}${branding.logoUrl}${cacheBust}`);
}
setLogoLoading(false);
};
const handleLogoFileChange = (e) => {
const file = e.target.files?.[0];
if (!file || logoMutationInFlight.current) return;
logoRequestId.current += 1;
setLogoLoading(false);
setLogoFile(file);
setLogoPreviewUrl(URL.createObjectURL(file));
};
const handleUploadLogo = async () => {
if (logoMutationInFlight.current) return;
if (!logoTargetDb || !logoFile) {
showToast('Please select a logo file first.');
return;
}
logoMutationInFlight.current = true;
logoRequestId.current += 1;
setLogoUploading(true);
try {
const token = localStorage.getItem('token');
const formData = new FormData();
formData.append('logo', logoFile);
const res = await axios.post(
`${process.env.REACT_APP_API_BASE_URL}/api/admin/database/${encodeURIComponent(logoTargetDb.datname)}/branding/logo`,
formData,
{
headers: {
'Content-Type': 'multipart/form-data',
Authorization: `Bearer ${token}`,
},
}
);
const cacheBust = res.data?.updatedAt ? `?v=${new Date(res.data.updatedAt).getTime()}` : `?v=${Date.now()}`;
setLogoPreviewUrl(`${process.env.REACT_APP_API_BASE_URL}${res.data.logoUrl}${cacheBust}`);
showToast('Logo updated successfully.');
window.dispatchEvent(new Event('register-branding-changed'));
setLogoDialogOpen(false);
} catch (err) {
console.error('❌ Failed to upload logo:', err);
showToast(err.response?.data?.message || 'Failed to upload logo.');
} finally {
logoMutationInFlight.current = false;
setLogoUploading(false);
}
};
const handleRemoveLogo = async () => {
if (!logoTargetDb || logoMutationInFlight.current) return;
logoMutationInFlight.current = true;
logoRequestId.current += 1;
setLogoUploading(true);
try {
const token = localStorage.getItem('token');
await axios.delete(
`${process.env.REACT_APP_API_BASE_URL}/api/admin/database/${encodeURIComponent(logoTargetDb.datname)}/branding/logo`,
{ headers: { Authorization: `Bearer ${token}` } }
);
setLogoPreviewUrl('');
setLogoFile(null);
showToast('Custom logo removed. The selected register theme is unchanged.');
window.dispatchEvent(new Event('register-branding-changed'));
setLogoDialogOpen(false);
} catch (err) {
console.error('❌ Failed to remove logo:', err);
showToast(err.response?.data?.message || 'Failed to remove logo.');
} finally {
logoMutationInFlight.current = false;
setLogoUploading(false);
}
};
const handleChecklistQuestionChange = (index, value) => {
setUseDefaultChecklistQuestions(false);
setChecklistQuestions((prev) => {
const next = [...prev];
next[index] = value;
return next;
});
};
const handleChecklistMaxQuestionsChange = (value) => {
const maxQuestions = resolveChecklistMaxQuestions(Number(value));
setChecklistMaxQuestions(maxQuestions);
setChecklistQuestions((previous) => toChecklistQuestionRows(previous, maxQuestions));
};
const handleUseDefaultChecklistChange = (checked) => {
setUseDefaultChecklistQuestions(checked);
if (checked) {
setChecklistQuestions(toChecklistQuestionRows(DEFAULT_CHECKLIST_QUESTIONS, checklistMaxQuestions));
}
};
const settingsDetailsUnavailable = selectedDatabase?.loadErrors?.some(field =>
['expiry', 'plan', 'contract'].includes(field) || (newPlanType === 'Custom' && ['users', 'items'].includes(field)));
const configuredChecklistQuestions = checklistQuestions
.map((q) => (typeof q === 'string' ? q.trim() : ''))
.filter(Boolean);
const checklistLimitExceeded = configuredChecklistQuestions.length > checklistMaxQuestions;
const handleSaveSettings = async () => {
if (settingsDetailsUnavailable || checklistLimitExceeded) return;
if (newPlanType === 'Custom' && (customUserLimit === '' || customItemLimit === '')) {
showToast('Enter both custom limits before saving. Use 0 for unlimited.');
return;
}
if (checklistLoading || checklistLoadError || rfidSettingsLoading || rfidSettingsError || settingsSaving) return;
if (!newExpiryDate.trim() || !newPlanType.trim()) {
showToast('Please enter a valid expiry date and select a plan type.');
return                                                                 ;
}
setSettingsSaving(true);
try {
const token = localStorage.getItem('token');
const expiryResponse = await axios.put(
`${process.env.REACT_APP_API_BASE_URL}/api/admin/database/${encodeURIComponent(selectedDatabase.datname)}/expiry`,
{ expiryDate: newExpiryDate },
{ headers: { Authorization: `Bearer ${token}` } }
)                                                                                                                  ;
let payload = { planType: newPlanType } ;
if (newPlanType === 'Custom') {
const userLimitValue = parseInt(customUserLimit, 10) || 0 ;
const itemLimitValue = parseInt(customItemLimit, 10) || 0 ;
payload.userLimit = userLimitValue ;
payload.itemLimit = itemLimitValue ;
}
const planResponse = await axios.put(
`${process.env.REACT_APP_API_BASE_URL}/api/admin/database/${encodeURIComponent(selectedDatabase.datname)}/plan`,
payload,
{ headers: { Authorization: `Bearer ${token}` } }
)                                                                                                                ;
await axios.put(
`${process.env.REACT_APP_API_BASE_URL}/api/admin/database/${encodeURIComponent(selectedDatabase.datname)}/contract`,
{ contractId: newContractId },
{ headers: { Authorization: `Bearer ${token}` } }
)                                                                                                                    ;
await axios.put(
`${process.env.REACT_APP_API_BASE_URL}/api/settings/database/${encodeURIComponent(selectedDatabase.datname)}/checklist`,
{
checklistEnabled,
supervisorEditEnabled,
useDefaultQuestions: useDefaultChecklistQuestions,
maxQuestions: checklistMaxQuestions,
questions: configuredChecklistQuestions,
},
{ headers: { Authorization: `Bearer ${token}` } }
)                                                                                                                    ;
await axios.put(
`${process.env.REACT_APP_API_BASE_URL}/api/settings/database/${encodeURIComponent(selectedDatabase.datname)}/rfid`,
{ statisticsEnabled: rfidStatisticsEnabled },
{ headers: { Authorization: `Bearer ${token}` } }
);
setDatabases((prev) =>
prev.map((db) =>
db.datname === selectedDatabase.datname
? { ...db, expiryDate: newExpiryDate, isExpired: undefined, daysUntilExpiry: undefined, planType: newPlanType, contractId: newContractId }
: db
)
)                                                             ;
const notificationTrackingReady =
expiryResponse.data?.notificationTrackingReady !== false &&
planResponse.data?.notificationTrackingReady !== false;
showToast(
notificationTrackingReady
? 'Database settings updated successfully.'
: 'Settings saved, but trial email tracking needs attention. Review this trial in Trial Requests.'
);
setEditDialogOpen(false);
fetchDatabaseData();
} catch (err) {
console.error('❌ Failed to update settings:', err) ;
showToast('Some settings may have saved. Reload this register before retrying.');
} finally {
setSettingsSaving(false);
}
}                                                    ;
const handleBackupDatabase = async (dbName) => {
if (backingUpDb) return;
setBackingUpDb(dbName);
try {
const token = localStorage.getItem('token');
const response = await axios.post(
`${process.env.REACT_APP_API_BASE_URL}/api/admin/database/${encodeURIComponent(dbName)}/backup`,
{},
{ headers: { Authorization: `Bearer ${token}` } }
)                                                                                                ;
showToast(response.data.message)                                                                 ;
} catch (err) {
console.error('❌ Error creating DB backup:', err)                   ;
if (err.response && err.response.data && err.response.data.message) {
showToast(err.response.data.message)                                  ;
} else {
showToast('Failed to backup database.');
}
} finally {
setBackingUpDb('');
}
}                                                                     ;
const handleConnectDatabase = async (dbName) => {
if (connectingDb || !confirmRegisterSwitch()) return;
try {
const token = localStorage.getItem('token');
if (!token || !dbName) return;
setConnectingDb(dbName);
const response = await axios.post(
`${process.env.REACT_APP_API_BASE_URL}/api/admin/database/${encodeURIComponent(dbName)}/connect`,
{},
{ headers: { Authorization: `Bearer ${token}` } }
);
if (response.data?.token) {
installRegisterSession(response.data.token);
// The remounted workspace loads its own user; this old handler must not publish one.
}
showToast(response.data?.message || `Connected to ${dbName}.`);
} catch (err) {
console.error('❌ Error connecting to database:', err.response || err);
showToast(err.response?.data?.message || 'Failed to connect to database.');
} finally {
setConnectingDb('');
}
}                                                                     ;
const openCreateDialog = () => {
setNewDbName('');
setNewDbExpiry('');
setNewDbContractId('');
setNewDbTemplate('empty');
setNewDbSetup(createRegisterSetup());
setCreateError('');
setCreateDialogOpen(true)        ;
}                                ;
const openTrialDialog = () => {
setTrialRegisterMode('new');
setTrialExistingDbName('');
setTrialCompanyName('');
setTrialContactFirstName('');
setTrialContactLastName('');
setTrialContactEmail('');
setTrialDbName('');
setTrialExpiry(dayjs().add(14, 'day').format('YYYY-MM-DD'));
setTrialContractId('');
setTrialTemplate('demo');
setTrialSetup(createRegisterSetup('Starter'));
setTrialDialogOpen(true);
}                                ;
const handleCloseTrialDialog = () => {
if (trialSubmissionInFlight.current) return;
setTrialDialogOpen(false);
};
useEffect(() => {
const params = new URLSearchParams(location.search);
if (params.get('openTrial') === '1') {
setTrialRegisterMode('new');
setTrialExistingDbName('');
setTrialCompanyName('');
setTrialContactFirstName('');
setTrialContactLastName('');
setTrialContactEmail('');
setTrialDbName('');
setTrialExpiry(dayjs().add(14, 'day').format('YYYY-MM-DD'));
setTrialContractId('');
setTrialTemplate('demo');
setTrialSetup(createRegisterSetup('Starter'));
setTrialDialogOpen(true);
navigate('/admin/databases', { replace: true });
}
}, [location.search, navigate])  ;
const handleCreateDatabase = async () => {
if (creationInFlight.current) return;
setCreateError('');
if (!newDbName.trim() || !newDbExpiry.trim()) {
setCreateError('Please enter a register name and expiry date.');
return                                                      ;
}
const validationError = registerSetupError(newDbSetup);
if (validationError) { setCreateError(validationError); return; }
creationInFlight.current = true;
setCreating(true);
try {
const token = localStorage.getItem('token');
const response = await axios.post(
`${process.env.REACT_APP_API_BASE_URL}/api/admin/database/create`,
{
newDatabaseName: newDbName.trim(),
expiryDate: newDbExpiry,
contractId: newDbContractId,
templateType: newDbTemplate,
...registerSetupPayload(newDbSetup),
},
{ headers: { Authorization: `Bearer ${token}` } }
)                                                                  ;
showToast(
response.data?.dbCode
? `${response.data.message || 'Database created!'} Code: ${response.data.dbCode}`
: (response.data.message || 'Database created!')
);
setCreateDialogOpen(false)                                            ;
fetchDatabaseData()                                                   ;
} catch (err) {
console.error('❌ Error creating database:', err.response || err)    ;
if (err.response && err.response.data && err.response.data.message) {
setCreateError(err.response.data.message);
} else {
setCreateError('Could not create the register. Check your connection and try again.');
}
} finally {
creationInFlight.current = false;
setCreating(false);
}
}                                                                     ;
const handleCreateTrialOnboarding = async () => {
if (trialSubmissionInFlight.current) return;
const usesExistingRegister = trialRegisterMode === 'existing';
if (usesExistingRegister && (loading || databaseLoadError || !trialExistingSettingsReady)) {
showToast('Please select a register with a valid code, plan, and expiry date.');
return;
}
if (!trialCompanyName.trim() || !trialContactEmail.trim() || (!usesExistingRegister && (!trialDbName.trim() || !trialExpiry.trim()))) {
showToast(usesExistingRegister
? 'Please enter the company and contact email.'
: 'Please enter the company, contact email, database name, and expiry date.');
return;
}
const normalizedTrialEmail = trialContactEmail.trim().toLowerCase();
if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedTrialEmail)) {
showToast('Please enter a valid contact email address.');
return;
}

if (!usesExistingRegister && registerSetupError(trialSetup)) {
showToast(registerSetupError(trialSetup));
return;
}
trialSubmissionInFlight.current = true;
setTrialSubmitting(true);
try {
const token = localStorage.getItem('token');
const registerPayload = usesExistingRegister ? {
existingDatabaseName: trialExistingDatabase.datname,
} : {
newDatabaseName: trialDbName,
expiryDate: trialExpiry,
contractId: trialContractId,
templateType: trialTemplate,
...registerSetupPayload(trialSetup),
};
const payload = {
...registerPayload,
companyName: trialCompanyName,
contactFirstName: trialContactFirstName,
contactLastName: trialContactLastName,
contactEmail: normalizedTrialEmail,
};

const response = await axios.post(
`${process.env.REACT_APP_API_BASE_URL}/api/admin/trial-onboarding`,
payload,
{ headers: { Authorization: `Bearer ${token}` } }
);

setTrialResult({ ...response.data, registerMode: usesExistingRegister ? 'existing' : 'new' });
setTrialDialogOpen(false);
setTrialResultDialogOpen(true);
showToast(
response.data.notificationTrackingReady === false
? `Trial ${usesExistingRegister ? 'bound' : 'created'}, but expiry email tracking needs attention. Review it in Trial Requests.`
: (response.data.message || 'Trial onboarding created.')
);
fetchDatabaseData();
} catch (err) {
console.error('❌ Error creating trial onboarding:', err.response || err);
if (err.response?.data?.message) {
showToast(err.response.data.message);
} else {
showToast('Failed to create trial onboarding.');
}
} finally {
trialSubmissionInFlight.current = false;
setTrialSubmitting(false);
}
}                                                                     ;
const handleCopyTrialValue = async (value, label) => {
if (!value) {
showToast(`No ${label.toLowerCase()} available to copy.`);
return;
}
try {
await navigator.clipboard.writeText(value);
showToast(`${label} copied.`);
} catch (err) {
showToast(`Failed to copy ${label.toLowerCase()}.`);
}
}                                                                     ;
const handleDeleteClick = (database) => {
setDbToDelete(database.datname);
setDeletionError('');
setConfirmationInput('');
setDeleteDialogOpen(true)                 ;
}                                         ;
const handleConfirmDelete = async () => {
if (deletionInFlight.current || !deletionPreview.preview) return;
if (confirmationInput.trim() !== dbToDelete.trim()) {
showToast('Database name mismatch. Please type the exact name.');
return                                                            ;
}
deletionInFlight.current = true;
setDeleting(true);
setDeletionError('');
try {
const token = localStorage.getItem('token');
const response = await axios.delete(
`${process.env.REACT_APP_API_BASE_URL}/api/admin/database/${encodeURIComponent(dbToDelete)}`,
{ headers: { Authorization: `Bearer ${token}` }, data: {
confirmationDatabaseName: confirmationInput, deletionToken: deletionPreview.preview.deletionToken,
} }
);
if (response.data?.token) { installRegisterSession(response.data.token); return; }
showToast(response.data.message || 'Register deleted.');
setDeleteDialogOpen(false)                                                                    ;
await fetchDatabaseData();
} catch (err) {
if (err.response?.data?.token) { installRegisterSession(err.response.data.token); return; }
setDeletionError(err.response?.data?.message || 'Failed to delete register. Retry to check the deletion status.');
if (err.response?.status === 409 || err.response?.data?.code === 'REGISTER_DELETE_INCOMPLETE') deletionPreview.reload();
} finally {
setDeleting(false);
deletionInFlight.current = false;
}
}                                                                                             ;
const handleCloseDeleteDialog = () => {
if (deleting) return;
setDeleteDialogOpen(false)              ;
setDbToDelete('');
setConfirmationInput('');
}                                       ;
const updateRegisterFilters = updates => {
const params = new URLSearchParams(location.search);
Object.entries(updates).forEach(([key, value]) => {
if (value && (key === 'q' || value !== 'all')) params.set(key, value);
else params.delete(key);
});
navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
};
const setStatusFilter = status => updateRegisterFilters({ status });
const setPlanFilter = plan => updateRegisterFilters({ plan });
const setSearchQuery = q => updateRegisterFilters({ q });
const filteredDatabases = filterRegisters(databases, { status: statusFilter, plan: planFilter, query: searchQuery });
const partialCount = databases.filter(database => database.loadErrors?.length).length;
const summary = [
{ label: 'All registers', value: 'all', count: databases.length, color: 'text.primary' },
{ label: 'Active', value: 'active', count: databases.filter(db => getRegisterStatus(db) === 'active').length, color: 'success.main' },
{ label: 'Expired', value: 'expired', count: databases.filter(db => getRegisterStatus(db) === 'expired').length, color: 'error.main' },
];
const CustomToolbar = () => (
<GridToolbarContainer sx={{ px: 2, py: 1, gap: 0.5, borderBottom: '1px solid', borderColor: 'divider' }}>
<GridToolbarColumnsButton />
<GridToolbarFilterButton />
<GridToolbarDensitySelector />
<GridToolbarExport />
<Typography variant="caption" color="text.secondary" sx={{ ml: 'auto' }}>
{filteredDatabases.length} of {databases.length} registers
</Typography>
</GridToolbarContainer>
);
const columns = [
  {
    field: 'datname', headerName: 'Register', flex: 1.3, minWidth: 200,
    renderCell: ({ row }) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%', minWidth: 0 }}>
        <Typography noWrap sx={{ fontSize: 14, fontWeight: 600 }}>{row.datname}</Typography>
        {user?.database_name === row.datname && <Tooltip title="Your connected register"><CheckCircleIcon sx={{ fontSize: 16, color: 'success.main' }} /></Tooltip>}
        {row.deletion_phase && <Chip label="Deletion pending" size="small" color="warning" />}
        {!!row.loadErrors?.length && <Tooltip title={`Unavailable: ${row.loadErrors.join(', ')}`}><Chip label="Partial" size="small" variant="outlined" color="warning" /></Tooltip>}
      </Box>
    ),
  },
  {
    field: 'status', headerName: 'Access status', minWidth: 170, flex: 0.9,
    valueGetter: (_value, row) => REGISTER_STATUSES[getRegisterStatus(row)].label,
    renderCell: ({ row }) => {
      const status = REGISTER_STATUSES[getRegisterStatus(row)];
      return <Chip label={status.label} color={status.color} size="small" variant="outlined" sx={{ fontSize: 12, fontWeight: 600 }} />;
    },
  },
  {
    field: 'expiryDate', headerName: 'Expires', minWidth: 125,
    renderCell: ({ row }) => row.loadErrors?.includes('expiry') ? 'Unavailable' : (row.expiryDate ? dayjs(row.expiryDate).format('DD MMM YYYY') : 'Not set'),
  },
  { field: 'planType', headerName: 'Plan', minWidth: 115 },
  { field: 'dbCode', headerName: 'Register code', minWidth: 130, renderCell: ({ row }) => row.loadErrors?.includes('code') ? 'Unavailable' : (row.dbCode || 'Not set') },
  { field: 'contractId', headerName: 'Contract', minWidth: 140, renderCell: ({ row }) => row.loadErrors?.includes('contract') ? 'Unavailable' : (row.contractId || 'Not set') },
  { field: 'userCount', headerName: 'Seats / limit', minWidth: 110, renderCell: ({ value }) => value ?? 'Unavailable' },
  { field: 'itemCount', headerName: 'Items / limit', minWidth: 120, renderCell: ({ value }) => value ?? 'Unavailable' },
  {
    field: 'actions', headerName: 'Manage', width: 220, sortable: false, filterable: false, disableExport: true,
    renderCell: ({ row }) => {
      const isConnected = user?.database_name === row.datname;
      return (
        <Box display="flex" gap={0.25}>
          <Tooltip title={isConnected ? 'Connected register' : 'Connect to Database'}>
            <span><IconButton aria-label={`Connect to ${row.datname}`} color={isConnected ? 'success' : 'default'} size="small" onClick={() => handleConnectDatabase(row.datname)} disabled={!!row.deletion_phase || isConnected || !!connectingDb}>
              {connectingDb === row.datname ? <CircularProgress size={18} /> : isConnected ? <CheckCircleIcon fontSize="small" /> : <LoginIcon fontSize="small" />}
            </IconButton></span>
          </Tooltip>
          <Tooltip title="Backup Database"><span><IconButton aria-label={`Back up ${row.datname}`} size="small" disabled={!!row.deletion_phase || !!backingUpDb} onClick={() => handleBackupDatabase(row.datname)}>
            {backingUpDb === row.datname ? <CircularProgress size={18} /> : <CloudDownload fontSize="small" />}
          </IconButton></span></Tooltip>
          <Tooltip title="Branding Logo"><span><IconButton aria-label={`Edit logo for ${row.datname}`} disabled={!!row.deletion_phase} size="small" onClick={() => handleOpenLogoDialog(row)}><ImageIcon fontSize="small" /></IconButton></span></Tooltip>
          <Tooltip title="Register settings"><span><IconButton aria-label="Edit Expiry Date" disabled={!!row.deletion_phase} size="small" onClick={() => handleEditExpiry(row)}><Edit fontSize="small" /></IconButton></span></Tooltip>
          <Tooltip title="Delete Database"><IconButton aria-label={`Delete ${row.datname}`} size="small" sx={{ color: 'text.secondary', '&:hover': { color: 'error.main', bgcolor: 'error.50' } }} onClick={() => handleDeleteClick(row)}><Delete fontSize="small" /></IconButton></Tooltip>
        </Box>
      );
    },
  },
];
return (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, width: '100%', minWidth: 0, flex: 1, minHeight: 520 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Button variant="outlined" startIcon={<RefreshIcon />} onClick={handleIndependentRefresh} disabled={loading}>{loading ? 'Refreshing…' : 'Refresh'}</Button>
        <Button variant="outlined" onClick={openTrialDialog}>New trial</Button>
        <Button variant="contained" startIcon={<AddIcon />} onClick={openCreateDialog}>Create register</Button>
      </Box>
    </Box>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {summary.map(card => (
        <Button key={card.value} onClick={() => setStatusFilter(card.value)} aria-pressed={statusFilter === card.value} sx={{ px: 1.5, py: .65, gap: 1.5, alignItems: 'center', flexDirection: 'row', textTransform: 'none', bgcolor: 'background.paper', border: '1px solid', borderColor: statusFilter === card.value ? 'primary.main' : 'divider', borderRadius: 2, color: 'text.primary', '&:hover': { bgcolor: 'action.hover' } }}>
          <Typography variant="body2" color="text.secondary">{card.label}</Typography>
          <Typography sx={{ fontSize: 18, lineHeight: 1.4, fontWeight: 600, color: card.color }}>{lastRefreshed ? card.count : '—'}</Typography>
        </Button>
      ))}
    </Box>
    {loadError && <Alert severity="error" action={<Button color="inherit" onClick={handleIndependentRefresh} disabled={loading}>Retry</Button>}>{loadError}</Alert>}
    {!!partialCount && <Alert severity="warning">Details are unavailable for {partialCount} {partialCount === 1 ? 'register' : 'registers'}. Values marked unavailable could not be verified. Refresh to retry.</Alert>}
    <Paper className="admin-table-card" elevation={0} sx={{ borderRadius: 1, overflow: 'hidden', border: '1px solid', borderColor: 'divider', display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, p: 2.5, alignItems: 'center' }}>
        <TextField size="small" label="Search registers" placeholder="Name, code, or contract" value={searchQuery} onChange={event => setSearchQuery(event.target.value)} sx={{ flex: '1 1 240px' }} InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
        <TextField select size="small" label="Access status" value={statusFilter} onChange={event => setStatusFilter(event.target.value)} sx={{ minWidth: 200 }}>
          <MenuItem value="all">All statuses</MenuItem>
          {Object.entries(REGISTER_STATUSES).map(([value, status]) => <MenuItem key={value} value={value}>{status.label}</MenuItem>)}
        </TextField>
        <TextField select size="small" label="Plan" value={planFilter} onChange={event => setPlanFilter(event.target.value)} sx={{ minWidth: 150 }}>
          <MenuItem value="all">All plans</MenuItem>
          {Array.from(new Set([...databases.map(db => db.planType), ...(planFilter !== 'all' ? [planFilter] : [])])).sort().map(plan => <MenuItem key={plan} value={plan}>{plan}</MenuItem>)}
        </TextField>
        {(statusFilter !== 'all' || planFilter !== 'all' || searchQuery) && <Button size="small" onClick={() => updateRegisterFilters({ status: 'all', plan: 'all', q: '' })}>Clear filters</Button>}
      </Box>
      <Box sx={{ flex: 1, minHeight: 360 }}>
        <DataGridPro
          rows={filteredDatabases}
          columns={columns}
          density={density}
          loading={loading}
          pagination
          disableRowSelectionOnClick
          pageSizeOptions={[25, 50, 100]}
          initialState={{ pagination: { paginationModel: { pageSize: 25 } }, columns: { columnVisibilityModel: { contractId: false } }, sorting: { sortModel: [{ field: 'datname', sort: 'asc' }] } }}
          getRowId={row => row.datname}
          onDensityChange={setDensity}
          sx={{ height: '100%', border: 'none', '& .MuiDataGrid-columnHeaders': { bgcolor: 'action.hover', borderBottom: '1px solid', borderColor: 'divider' }, '& .MuiDataGrid-cell': { borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', fontSize: 14 }, '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 600 } }}
          slots={{ toolbar: CustomToolbar, noRowsOverlay: () => <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>{loadError ? 'Register data is unavailable. Retry above.' : databases.length ? 'No registers match your filters.' : 'No registers yet. Create a register to get started.'}</Box> }}
        />
      </Box>
      {lastRefreshed && <Typography variant="caption" color="text.secondary" sx={{ display: 'block', px: 2, py: 1, borderTop: '1px solid', borderColor: 'divider' }}>Last refreshed {dayjs(lastRefreshed).format('HH:mm:ss')} · Expiry remains valid through the displayed date.</Typography>}
    </Paper>
{editDialogOpen && (
<Dialog open onClose={handleCloseSettings} maxWidth="md" fullWidth>
<DialogTitle>Register settings<Typography variant="body2" color="text.secondary">{selectedDatabase?.datname}</Typography></DialogTitle>
<DialogContent dividers>
{settingsDetailsUnavailable && <Alert severity="warning" sx={{ mb: 2 }}>Some register settings could not be loaded. Close this dialog and refresh the register list before saving.</Alert>}
<Box component="fieldset" disabled={settingsSaving} sx={{ border: 0, p: 0, m: 0, minWidth: 0 }}>
<TextField
label="Expiry Date"
type="date"
fullWidth
value={newExpiryDate}
onChange={(e) => setNewExpiryDate(e.target.value)}
InputLabelProps={{ shrink: true }}
sx={{ mt: 2 }}
/>
<TextField
select
label="Plan Type"
fullWidth
value={newPlanType}
onChange={(e) => setNewPlanType(e.target.value)}
sx={{ mt: 2 }}
>
{['Mini', 'Starter', 'Professional', 'Business', 'Custom'].map((plan) => (
<MenuItem key={plan} value={plan}>
{plan}
</MenuItem>
))}
</TextField>
<TextField
label="Contract ID"
fullWidth
value={newContractId}
onChange={(e) => setNewContractId(e.target.value)}
sx={{ mt: 2 }}
/>
{newPlanType === 'Custom' && (
<>
<TextField
label="Custom User Limit"
type="number"
fullWidth
value={customUserLimit}
onChange={(e) => setCustomUserLimit(e.target.value)}
sx={{ mt: 2 }}
/>
<TextField
label="Custom Item Limit"
type="number"
fullWidth
value={customItemLimit}
onChange={(e) => setCustomItemLimit(e.target.value)}
sx={{ mt: 2 }}
/>
</>
)}
<Divider sx={{ mt: 3, mb: 2 }} />
<Typography sx={{ fontWeight: 600 }}>RFID statistics</Typography>
{rfidSettingsLoading && <CircularProgress size={18} aria-label="Loading RFID settings" />}
{rfidSettingsError && <Alert severity="error" sx={{ mt: 1 }}>
Could not load RFID settings. Reload them before saving.
<Button onClick={() => loadRfidSettings(selectedDatabase.datname)}>Retry RFID settings</Button>
</Alert>}
<FormControlLabel
control={<Switch checked={rfidStatisticsEnabled}
onChange={(event) => setRfidStatisticsEnabled(event.target.checked)}
disabled={rfidSettingsLoading || rfidSettingsError} />}
label="Show RFID statistics on this register's dashboard"
/>
<Typography variant="body2" color="text.secondary">
Controls the dashboard button. Tag scanning and confirmation tracking remain available when statistics are hidden.
</Typography>
<Divider sx={{ mt: 3, mb: 2 }} />
<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 1 }}>
<Typography sx={{ fontWeight: 600 }}>Inspection Checklist</Typography>
{checklistLoading && <CircularProgress size={18} />}
</Box>
{checklistLoadError && (
<Box role="alert" sx={{ mb: 1, color: 'error.main' }}>
Could not load inspection settings. Reload them before saving.
<Button onClick={() => loadChecklistSettings(selectedDatabase.datname)}>Retry</Button>
</Box>
)}
<FormControlLabel
control={
<Switch
checked={checklistEnabled}
onChange={(e) => setChecklistEnabled(e.target.checked)}
disabled={checklistLoading || checklistLoadError}
/>
}
label="Enable checklist process for this database"
sx={{ mt: 0.5 }}
/>
<FormControlLabel
control={
<Switch
checked={supervisorEditEnabled}
onChange={(e) => setSupervisorEditEnabled(e.target.checked)}
disabled={checklistLoading || checklistLoadError || !checklistEnabled}
/>
}
label="Allow register supervisors to edit inspection questions"
sx={{ mt: 0.5 }}
/>
<Typography sx={{ mt: 0.5, fontSize: 14, color: 'rgba(15,17,21,0.62)' }}>
When the checklist is enabled, supervisors in this register can configure up to {checklistMaxQuestions} questions using Inspections on their dashboard.
</Typography>
<TextField
select
label="Approved question limit"
value={checklistMaxQuestions}
onChange={(event) => handleChecklistMaxQuestionsChange(event.target.value)}
SelectProps={{ native: true }}
disabled={checklistLoading || checklistLoadError}
size="small"
fullWidth
sx={{ mt: 2, mb: 1 }}
helperText="Applies only to this register. Inspectors see the questions that are filled in."
>
{Array.from({ length: MAX_CHECKLIST_QUESTIONS - DEFAULT_CHECKLIST_MAX_QUESTIONS + 1 }, (_, index) => {
const limit = DEFAULT_CHECKLIST_MAX_QUESTIONS + index;
return <option key={limit} value={limit}>{limit}</option>;
})}
</TextField>
<FormControlLabel
control={
<Switch
checked={useDefaultChecklistQuestions}
onChange={(e) => handleUseDefaultChecklistChange(e.target.checked)}
disabled={checklistLoading || checklistLoadError}
/>
}
label="Use default checklist questions (prefill)"
sx={{ mt: 0.5 }}
/>
<Typography sx={{ mt: 1, fontSize: 14, color: 'rgba(15,17,21,0.62)' }}>
Up to {checklistMaxQuestions} questions. Leave rows blank if not used. Default prefill contains 20 questions.
</Typography>
{checklistLimitExceeded && (
<Alert severity="error" sx={{ mt: 1 }}>
There are {configuredChecklistQuestions.length} filled questions. Clear {configuredChecklistQuestions.length - checklistMaxQuestions} {configuredChecklistQuestions.length - checklistMaxQuestions === 1 ? 'question' : 'questions'} or increase the approved limit before saving. Existing inspection records keep their original questions.
</Alert>
)}
<Box
sx={{
mt: 1.5,
display: 'grid',
gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
gap: 1.5,
maxHeight: 420,
overflowY: 'auto',
pr: 0.5,
}}
>
{checklistQuestions.map((question, idx) => (
<TextField
key={`checklist-question-${idx}`}
id={`admin-checklist-question-${idx + 1}`}
label={`Question ${idx + 1}`}
value={question}
onChange={(e) => handleChecklistQuestionChange(idx, e.target.value)}
size="small"
fullWidth
disabled={checklistLoading || checklistLoadError}
inputProps={{ maxLength: 500 }}
/>
))}
</Box>
</Box>
</DialogContent>
<DialogActions>
<Button onClick={handleCloseSettings} disabled={settingsSaving}>Cancel</Button>
<Button onClick={handleSaveSettings} variant="contained" disabled={checklistLoading || checklistLoadError || rfidSettingsLoading || rfidSettingsError || settingsSaving || settingsDetailsUnavailable || checklistLimitExceeded}>
{settingsSaving ? 'Saving...' : 'Save'}
</Button>
</DialogActions>
</Dialog>
)}
{createDialogOpen && (
<Dialog open onClose={() => { if (!creationInFlight.current) setCreateDialogOpen(false); }} maxWidth="md" fullWidth>
<DialogTitle>Create register<Typography variant="body2" color="text.secondary">Set up the plan, limits, and inspection options before creating the register.</Typography></DialogTitle>
<DialogContent dividers>
{createError && <Alert severity="error" sx={{ mb: 2 }}>{createError}</Alert>}
<Box component="fieldset" disabled={creating} sx={{ border: 0, p: 0, m: 0, minWidth: 0 }}>
<FormLabel component="legend" sx={{ mt: 2 }}>Template</FormLabel>
<RadioGroup
row
value={newDbTemplate}
onChange={(e) => setNewDbTemplate(e.target.value)}
>
<FormControlLabel value="empty" control={<Radio />} label="Empty" />
<FormControlLabel value="demo" control={<Radio />} label="Demo" />
</RadioGroup>
<TextField
label="Database Name"
required
fullWidth
value={newDbName}
onChange={(e) => setNewDbName(e.target.value)}
sx={{ mt: 2 }}
/>
<TextField
label="Expiry Date"
type="date"
required
fullWidth
value={newDbExpiry}
onChange={(e) => setNewDbExpiry(e.target.value)}
InputLabelProps={{ shrink: true }}
sx={{ mt: 2 }}
/>
<TextField
label="Contract ID"
fullWidth
value={newDbContractId}
onChange={(e) => setNewDbContractId(e.target.value)}
sx={{ mt: 2 }}
/>
<RegisterSetupFields value={newDbSetup} onChange={setNewDbSetup} disabled={creating} />
</Box>
</DialogContent>
<DialogActions>
<Button onClick={() => { if (!creationInFlight.current) setCreateDialogOpen(false); }} disabled={creating}>
Cancel
</Button>
<Button variant="contained" onClick={handleCreateDatabase} disabled={creating || !!registerSetupError(newDbSetup)}>
{creating ? 'Creating…' : 'Create'}
</Button>
</DialogActions>
</Dialog>
)}
{trialDialogOpen && (
<Dialog open onClose={handleCloseTrialDialog} maxWidth="md" fullWidth>
<DialogTitle>Create Trial Onboarding</DialogTitle>
<DialogContent>
<Typography sx={{ mt: 1, fontSize: 14, color: 'rgba(15,17,21,0.62)' }}>
Create a trial with a new or existing register and send the onboarding email in one step.
</Typography>
<FormLabel id="trial-register-label" component="legend" sx={{ mt: 2 }}>Trial register</FormLabel>
<RadioGroup
row
aria-labelledby="trial-register-label"
value={trialRegisterMode}
onChange={(e) => setTrialRegisterMode(e.target.value)}
>
<FormControlLabel value="new" control={<Radio />} label="Create new register" disabled={trialSubmitting} />
<FormControlLabel value="existing" control={<Radio />} label="Use existing register" disabled={trialSubmitting} />
</RadioGroup>
{trialRegisterMode === 'existing' && (
<>
<Autocomplete
options={databaseLoadError ? [] : trialRegisterOptions}
value={trialExistingDatabase}
onChange={(_, database) => setTrialExistingDbName(database?.datname || '')}
getOptionLabel={(database) => database.datname}
isOptionEqualToValue={(option, value) => option.datname === value.datname}
loading={loading}
disabled={trialSubmitting || loading || databaseLoadError}
noOptionsText="No registers available"
renderInput={(params) => (
<TextField
{...params}
label="Existing Register"
required
helperText={loading ? 'Loading registers and their settings…' : 'Search by register name'}
/>
)}
sx={{ mt: 2 }}
/>
{databaseLoadError && (
<Box role="alert" sx={{ mt: 1 }}>
<Typography color="error" variant="body2">Could not load registers. Retry to choose an existing register.</Typography>
<Button onClick={fetchDatabaseData} disabled={trialSubmitting || loading}>Retry</Button>
</Box>
)}
{trialExistingDatabase && !loading && !databaseLoadError && (
<Box sx={{ mt: 2, p: 1.5, bgcolor: 'action.hover', borderRadius: 1 }}>
<Typography variant="body2">Register code: <strong>{trialExistingDatabase.dbCode || 'Unavailable'}</strong></Typography>
<Typography variant="body2">Plan: <strong>{trialExistingDatabase.planType || 'Unavailable'}</strong></Typography>
<Typography variant="body2">Expiry: <strong>{trialExistingDatabase.expiryDate && dayjs(trialExistingDatabase.expiryDate).isValid()
? dayjs(trialExistingDatabase.expiryDate).format('YYYY-MM-DD') : 'Unavailable'}</strong></Typography>
{!trialExistingSettingsReady && (
<Box role="alert" sx={{ mt: 1 }}>
<Typography color="error" variant="body2">This register needs a valid register code, plan, and expiry date. Check its settings or retry loading them.</Typography>
<Button onClick={fetchDatabaseData} disabled={trialSubmitting}>Retry</Button>
</Box>
)}
</Box>
)}
<Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
The trial uses this register’s current code, plan, and expiry. Edit the register’s expiry in its settings beforehand if needed. Manage registers already linked to a trial in Trial Requests.
</Typography>
</>
)}
<TextField
label="Company Name"
required
fullWidth
value={trialCompanyName}
onChange={(e) => setTrialCompanyName(e.target.value)}
sx={{ mt: 2 }}
/>
<Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, mt: 0 }}>
<TextField
label="Contact First Name"
required
fullWidth
value={trialContactFirstName}
onChange={(e) => setTrialContactFirstName(e.target.value)}
sx={{ mt: 2 }}
/>
<TextField
label="Contact Last Name"
required
fullWidth
value={trialContactLastName}
onChange={(e) => setTrialContactLastName(e.target.value)}
sx={{ mt: 2 }}
/>
</Box>
<TextField
label="Contact Email"
type="email"
required
fullWidth
value={trialContactEmail}
onChange={(e) => setTrialContactEmail(e.target.value)}
sx={{ mt: 2 }}
/>
{trialRegisterMode === 'new' && (
<>
<FormLabel component="legend" sx={{ mt: 2 }}>Template</FormLabel>
<RadioGroup
row
value={trialTemplate}
onChange={(e) => setTrialTemplate(e.target.value)}
>
<FormControlLabel value="demo" control={<Radio />} label="Demo" />
<FormControlLabel value="empty" control={<Radio />} label="Empty" />
</RadioGroup>
<TextField
label="Database Name"
required
fullWidth
value={trialDbName}
onChange={(e) => setTrialDbName(e.target.value)}
sx={{ mt: 2 }}
helperText="Internal register name used for the client workspace"
/>
<TextField
label="Expiry Date"
type="date"
required
fullWidth
value={trialExpiry}
onChange={(e) => setTrialExpiry(e.target.value)}
InputLabelProps={{ shrink: true }}
sx={{ mt: 2 }}
/>
<TextField
label="Contract ID"
fullWidth
value={trialContractId}
onChange={(e) => setTrialContractId(e.target.value)}
sx={{ mt: 2 }}
helperText="Optional internal or CRM reference"
/>
<RegisterSetupFields value={trialSetup} onChange={setTrialSetup} disabled={trialSubmitting} />
</>
)}
</DialogContent>
<DialogActions>
<Button onClick={handleCloseTrialDialog} color="secondary" disabled={trialSubmitting}>
Cancel
</Button>
<Button variant="contained" onClick={handleCreateTrialOnboarding} disabled={trialSubmitting || (trialRegisterMode === 'new' && !!registerSetupError(trialSetup)) || (trialRegisterMode === 'existing' && (loading || databaseLoadError || !trialExistingSettingsReady))}>
{trialSubmitting ? (trialRegisterMode === 'existing' ? 'Binding…' : 'Creating…') : (trialRegisterMode === 'existing' ? 'Bind Trial' : 'Create Trial')}
</Button>
</DialogActions>
</Dialog>
)}
{trialResultDialogOpen && trialResult && (
<Dialog open onClose={() => setTrialResultDialogOpen(false)} maxWidth="sm" fullWidth>
<DialogTitle>Trial Onboarding Ready</DialogTitle>
<DialogContent dividers>
<Typography sx={{ fontSize: 14, fontWeight: 600, color: '#0f1115' }}>
{trialResult.emailSent && trialResult.notificationTrackingReady !== false
? 'Onboarding email sent and trial notifications are ready.'
: `Trial ${trialResult.registerMode === 'existing' ? 'bound to the existing register' : 'created'}, but email automation needs attention.`}
</Typography>
<Typography sx={{ mt: 1.5, fontSize: 14, color: 'rgba(15,17,21,0.7)' }}>
Database: <strong>{trialResult.databaseName}</strong>
</Typography>
<Typography sx={{ mt: 0.8, fontSize: 14, color: 'rgba(15,17,21,0.7)' }}>
Contact: <strong>{trialResult.contactEmail}</strong>
</Typography>
<Typography sx={{ mt: 0.8, fontSize: 14, color: 'rgba(15,17,21,0.7)' }}>
Register code: <strong>{trialResult.dbCode}</strong>
</Typography>
{trialResult.emailError && (
<Typography sx={{ mt: 1.5, fontSize: 14, color: '#b42318' }}>
Email error: {trialResult.emailError}
</Typography>
)}
{trialResult.lifecycleTrackingReady === false && (
<Typography sx={{ mt: 1.5, fontSize: 14, color: '#b54708' }}>
Expiry notification tracking could not be initialized, so the invitation was not sent and its link is hidden. Open Trial Requests and initialize tracking before generating a new link.
</Typography>
)}
{trialResult.lifecycleTrackingReady !== false && trialResult.invitationDeliveryTrackingReady === false && (
<Typography sx={{ mt: 1.5, fontSize: 14, color: '#b54708' }}>
The invitation delivery result could not be recorded. The valid link remains available below, but verify the delivery status before resending it.
</Typography>
)}
{trialResult.inviteLinkReady !== false && trialResult.inviteUrl && (
<TextField
label="Invite Link"
fullWidth
value={trialResult.inviteUrl}
margin="normal"
InputProps={{ readOnly: true }}
/>
)}
</DialogContent>
<DialogActions>
<Button onClick={() => handleCopyTrialValue(trialResult.dbCode, 'Register code')}>
Copy Code
</Button>
{trialResult.inviteLinkReady !== false && trialResult.inviteUrl && (
<Button onClick={() => handleCopyTrialValue(trialResult.inviteUrl, 'Invite link')}>
Copy Link
</Button>
)}
<Button variant="contained" onClick={() => setTrialResultDialogOpen(false)}>
Close
</Button>
</DialogActions>
</Dialog>
)}
{logoDialogOpen && (
<Dialog open onClose={handleCloseLogoDialog} maxWidth="sm" fullWidth>
<DialogTitle>Update Branding Logo<Typography variant="body2" color="text.secondary">{logoTargetDb?.datname}</Typography></DialogTitle>
<DialogContent dividers>
<Typography sx={{ mb: 1, fontSize: 14, color: 'rgba(15,17,21,0.72)' }}>
Upload a client-specific logo to replace the EXREG navbar logo for this database.
</Typography>
<Box
  sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    alignItems: 'flex-start',
  }}
>
  <Box
    sx={{
      width: '100%',
      minHeight: 90,
      border: '1px dashed rgba(15,17,21,0.2)',
      borderRadius: 1.5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(15,17,21,0.02)',
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    {logoLoading ? (
      <CircularProgress size={22} />
    ) : logoPreviewUrl ? (
      <img
        src={logoPreviewUrl}
        alt="Current logo preview"
        style={{ maxHeight: 80, maxWidth: '90%', objectFit: 'contain' }}
      />
    ) : (
      <Typography sx={{ fontSize: 14, color: 'rgba(15,17,21,0.62)' }}>
        No logo set yet.
      </Typography>
    )}
  </Box>
  <Button variant="outlined" component="label" size="small" disabled={logoUploading}>
    Choose File
    <input
      type="file"
      accept="image/png,image/jpeg,image/webp"
      disabled={logoUploading}
      hidden
      onChange={handleLogoFileChange}
    />
  </Button>
  {logoFile && (
    <Typography sx={{ fontSize: 12, color: 'rgba(15,17,21,0.72)' }}>
      Selected: {logoFile.name}
    </Typography>
  )}
  <Typography sx={{ fontSize: 12, color: 'rgba(15,17,21,0.62)' }}>
    Recommended: transparent PNG, max 576px wide. Files over 5MB are rejected.
  </Typography>
</Box>
</DialogContent>
<DialogActions>
<Button
  color="error"
  onClick={handleRemoveLogo}
  disabled={logoUploading || logoLoading}
>
  Remove Logo
</Button>
<Button onClick={handleCloseLogoDialog} disabled={logoUploading}>Cancel</Button>
<Button
  variant="contained"
  onClick={handleUploadLogo}
  disabled={logoUploading || !logoFile}
>
  {logoUploading ? 'Uploading…' : 'Save Logo'}
</Button>
</DialogActions>
</Dialog>
)}
{deleteDialogOpen && <Dialog open onClose={handleCloseDeleteDialog}>
<DialogTitle>Delete register</DialogTitle>
<DialogContent>
<Box>
<RegisterDeletionPreview state={deletionPreview} />
{deletionError && <Alert severity="error" sx={{ mb: 2 }}>{deletionError}</Alert>}
<p>Type <strong>{dbToDelete}</strong> to confirm deletion.</p>
<TextField
label="Database Name"
fullWidth
value={confirmationInput}
disabled={deleting}
onChange={(e) => setConfirmationInput(e.target.value)}
/>
</Box>
</DialogContent>
<DialogActions>
<Button onClick={handleCloseDeleteDialog} disabled={deleting}>
Cancel
</Button>
<Button variant="contained" color="error" onClick={handleConfirmDelete} disabled={deleting || !deletionPreview.preview || !dbToDelete || confirmationInput.trim() !== dbToDelete.trim()}>
{deleting ? 'Deleting…' : 'Delete'}
</Button>
</DialogActions>
</Dialog>}
<Snackbar
open={snackbarOpen}
autoHideDuration={3000}
onClose={() => setSnackbarOpen(false)}
message={snackbarMessage}
/>
</Box>
)                                      ;
}                                      ;
export default DatabaseManagement ;
